import React from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import './DateRange.css'
import { IconCalendar } from "@tabler/icons-react";

const DateRange = ({ onApplyClick, date, cssClass }) => {
  return (
    <div className={`datepicker-section border-2 ${cssClass}`}>
      <IconCalendar size={16} />
      <DateRangePicker initialSettings={{ startDate: date?.startDate || new Date(), endDate: date?.endDate || new Date(), opens: 'left', parentEl: '#mainContent' }} onApply={(e, p) => onApplyClick(p)} >
        <input type="text" className="bg-transparent focus:outline-none focus:border-none w-full !outline-none" />
      </DateRangePicker>
    </div>
  );
}

export default DateRange;